import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:id/:tunnel',
    name: 'home',
    component: () => import( '../views/HomeView.vue')
  },
  {
    path: '/',
    redirect: to => {
      window.location = "https://judosfo.ru"
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
